// Utility for formatting messages with pluralization support

// Example usage:
// const formatter = new MessageFormatter('en');
// const message = formatter.format("{count, plural, =0 {No items} one {# item} other {# items}} found", { count: 5 });

// Output: "5 items found"
// Supports exact number matches (e.g., =0) and plural categories (zero, one, two, few, many, other)
// based on Intl.PluralRules

// Note: This is a simplified implementation and may need to be extended for full ICU message format support

export class MessageFormatter {
    constructor(locale) {
        this.locale = locale;
        this.pluralRules = new Intl.PluralRules(locale);
    }

    format(message, variables = {}) {
        if (!message || typeof message !== 'string' || message.length === 0) {
            return '';
        }

        if (!message.includes('{')) {
            return message;
        }

        if (Object.keys(variables).length === 0) {
            return message;
        }

        let result = message;

        result = result.replace(
            /\{(\w+),\s*plural,\s*([^}]+(?:\}[^}]*)*)\}/g,
            (match, varName, pluralForms) => {
                const value = variables[varName];

                if (value === undefined) return match;

                const formMap = this.parsePluralForms(pluralForms);

                if (formMap[`=${value}`]) {
                    return formMap[`=${value}`].replace(/#/g, value);
                }

                const pluralCategory = this.pluralRules.select(value);
                const selectedForm =
                    formMap[pluralCategory] || formMap['other'] || '';

                return selectedForm.replace(/#/g, value);
            }
        );

        result = result.replace(/\{(\w+)\}/g, (match, variable) => {
            return variables[variable] !== undefined
                ? variables[variable]
                : match;
        });

        return result;
    }

    parsePluralForms(pluralForms) {
        const formMap = {};
        const formRegex = /(=\d+|zero|one|two|few|many|other)\s*\{([^}]*)\}/g;
        let formMatch;

        while ((formMatch = formRegex.exec(pluralForms)) !== null) {
            const [, formKey, formValue] = formMatch;
            formMap[formKey] = formValue;
        }

        return formMap;
    }
}
